function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.737 11.342a1.158 1.158 0 01-1.071 1.155l-.087.003H6.421a1.158 1.158 0 01-1.155-1.071l-.003-.087h3.474zM7 1.5a4.053 4.053 0 014.05 3.914l.003.139v2.179l1.054 2.11a.637.637 0 01-.503.918l-.066.003H2.462a.637.637 0 01-.596-.86l.027-.062 1.054-2.11V5.554A4.053 4.053 0 017 1.5z",
  fill: "currentColor"
});

var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgNotification;